export default __webpack_public_path__ + "static/media/top-k-6-med.edc552c2.jpg";